import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Register.css';

const Register = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [nombre, setNombre] = useState('');
    const [apellido, setApellido] = useState('');
    const [areaCode, setAreaCode] = useState('011');     // código de área (5 dígitos)
    const [phonePart1, setPhonePart1] = useState('');    // primeros 4 dígitos
    const [phonePart2, setPhonePart2] = useState('');    // últimos 4 dígitos
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const { register } = useAuth();

    // Validar que cada parte tenga la cantidad correcta de dígitos
    const isValidPhone = () => {
        const areaClean = areaCode.replace(/\D/g, '');
        const p1 = phonePart1.replace(/\D/g, '');
        const p2 = phonePart2.replace(/\D/g, '');
        return areaClean.length === 3 && p1.length === 4 && p2.length === 4;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');

        if (!isValidPhone()) {
            setError('El teléfono debe tener el formato: 011 - 4444 - 5555');
            return;
        }

        // Combinar las partes en un solo string con formato "11 - 4444 - 5555"
        const telefonoCompleto = `${areaCode} - ${phonePart1} - ${phonePart2}`;

        try {
            const res = await register({
                email,
                password,
                nombre,
                apellido,
                telefono: telefonoCompleto
            });
            //setMessage(res.data.message);
            setMessage('Registro exitoso. Por favor, revisa tu correo para verificar tu cuenta.');
            // Limpiar campos si se desea
        } catch (err) {
            setError(err.response?.data?.message || 'Error en registro');
        }
    };

    return (
        <div className="register-wrapper">
            <div className="register-container">
                <div className="register-box">
                    <div className="register-header">
                        <h2>Registro</h2>
                        <p>Crea tu cuenta</p>
                    </div>
                    {error && <div className="alert alert-danger">{error}</div>}
                    {message && <div className="alert alert-success">{message}</div>}
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label>Nombre</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Tu nombre"
                                value={nombre}
                                onChange={(e) => setNombre(e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label>Apellido</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Tu apellido"
                                value={apellido}
                                onChange={(e) => setApellido(e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label>Email</label>
                            <input
                                type="email"
                                className="form-control"
                                placeholder="ejemplo@correo.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label>Contraseña</label>
                            <input
                                type="password"
                                className="form-control"
                                placeholder="Mínimo 6 caracteres"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                minLength={6}
                            />
                        </div>

                        {/* Nuevo campo de teléfono en tres partes */}
                        <div className="form-group">
                            <label>Teléfono</label>
                            <div className="phone-group">
                                <div className="phone-area">
                                    <input
                                        type="text"
                                        className="form-control phone-input"
                                        placeholder="011"
                                        value={areaCode}
                                        onChange={(e) => {
                                            const val = e.target.value.replace(/\D/g, '');
                                            if (val.length <= 5) setAreaCode(val);
                                        }}
                                        required
                                        maxLength={5}
                                    />
                                    {/* <span className="phone-separator">-</span> */}
                                </div>
                                <div className="phone-part">
                                    <input
                                        type="text"
                                        className="form-control phone-input"
                                        placeholder="4444"
                                        value={phonePart1}
                                        onChange={(e) => {
                                            const val = e.target.value.replace(/\D/g, '');
                                            if (val.length <= 4) setPhonePart1(val);
                                        }}
                                        required
                                        maxLength={4}
                                    />
                                    {/* <span className="phone-separator">-</span> */}
                                </div>
                                <div className="phone-part">
                                    <input
                                        type="text"
                                        className="form-control phone-input"
                                        placeholder="5555"
                                        value={phonePart2}
                                        onChange={(e) => {
                                            const val = e.target.value.replace(/\D/g, '');
                                            if (val.length <= 4) setPhonePart2(val);
                                        }}
                                        required
                                        maxLength={4}
                                    />
                                </div>
                            </div>
                            <small className="text-muted">Ejemplo: 011 - 4444 - 5555</small>
                        </div>

                        <button type="submit" className="btn btn-primary w-100">
                            Registrarse
                        </button>

                    </form>
                    <div className="register-footer">
                        <Link to="/login">Volver al inicio de sesión</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Register;